import toastAvocado from '../assets/toast-avocado.png';
import { colors } from '../lib/theme';

interface Props {
  message: string;
  visible: boolean;
}

export default function Toast({ message, visible }: Props) {
  return (
    <div
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: '1.5rem',
        right: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.6rem',
        background: colors.mint,
        color: colors.mintText,
        borderRadius: 999,
        padding: '0.4rem 1.1rem 0.4rem 0.4rem',
        boxShadow: '0 6px 20px rgba(0,0,0,0.18)',
        transform: visible ? 'translateY(0)' : 'translateY(16px)',
        opacity: visible ? 1 : 0,
        pointerEvents: 'none',
        transition: 'transform 0.25s ease, opacity 0.25s ease',
        zIndex: 100,
      }}
    >
      <img src={toastAvocado} alt="" width={40} height={40} />
      <span style={{ fontWeight: 700 }}>{message}</span>
    </div>
  );
}
